<template>
    <User />
</template>

<script>
import User from '@/components/User.vue'
export default {
    name: 'userview',
    components: {
        User,
    }
};
</script>